import * as types from "../constants/ActionTypes";

const isFuturePauseActive = (state = false, action) => {
  switch (action.type) {
    case types.SET_IS_FUTURE_PAUSE_ACTIVE:
      return action.status;
    default:
      return state;
  }
};

export default isFuturePauseActive;
